export const isFProject = window.location.host.includes('f-project');
